module.exports = __webpack_public_path__ + "img/rightArrow.c2341aee.svg";